import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Modal from '@spothero/ui/modal';
import ModalContent from '@spothero/ui/modal-content';
import AirportDateTimePickers from 'common/airport/date-pickers/AirportDateTimePickers';

const ConfirmDateTimeModal = ({
    starts,
    ends,
    isFetchingRates,
    isEditMode,
    onApply,
    onConfirm,
    onHidden,
    errorMessage,
}) => {
    const classes = classNames('ConfirmDateTimeModal', {
        'ConfirmDateTimeModal-confirming': !isEditMode,
    });

    return (
        <Modal
            className={classes}
            title={`${isEditMode ? '' : 'Confirm '}Parking Reservation Time`}
            onHidden={onHidden}
        >
            <ModalContent>
                <AirportDateTimePickers
                    className="ConfirmDateTimeModal-airport-date-time-pickers"
                    startDateLabelText="Start Date"
                    endDateLabelText="End Date"
                    startTimeLabelText="Start Time"
                    endTimeLabelText="End Time"
                    starts={starts}
                    ends={ends}
                    isLoading={isFetchingRates}
                    searchButtonText={isEditMode ? 'Apply' : 'Checkout'}
                    onSearchClick={isEditMode ? onApply : onConfirm}
                />
                {errorMessage && (
                    <span className="ConfirmDateModal-error">
                        {errorMessage}
                    </span>
                )}
            </ModalContent>
        </Modal>
    );
};

ConfirmDateTimeModal.propTypes = {
    isFetchingRates: PropTypes.bool,
    starts: PropTypes.string,
    ends: PropTypes.string,
    isEditMode: PropTypes.bool,
    onApply: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    onHidden: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
};

export default ConfirmDateTimeModal;
